import $ from 'jquery';
// import $ from "jquery";

/** Used in community page for switching next */
export function initFanArchive() {

	$(".nextFanArchive").on('click',function(  ) {
	    let fanArchivePage = $(this).attr('page-current');
	    const limit = $(this).attr('page-size');
	    const count = $(this).attr('page-count');

        fanArchivePage++;
	    $.post(
	        '/community/ajax/getfansarchiveajax', // url
	        {'page':fanArchivePage,'limit':limit}, // data
	        function(data){
	            $(".front").flip({
	                direction:'rl',
	                content: (data),
	                onEnd: function(){
	                    $(".nextFanArchive").attr('page-current',fanArchivePage);
	                    $(".previousFanArchive").attr('page-current',fanArchivePage -2);
	                    updateFlipNextPreviousButton(fanArchivePage,count);
	                    // InitializeFancybox();
	                }
	            });

	        }, // callback
		);

	});


    $(".previousFanArchive").on('click',function(  ) {
        let fanArchivePage = $(".nextFanArchive").attr('page-current');
	    const limit = $(this).attr('page-size');
	    const count = $(this).attr('page-count');

        fanArchivePage--;
        $.post(
            '/community/ajax/getfansarchiveajax', // url
            {'page':fanArchivePage,'limit':limit}, // data
            function(data){
                $(".front").flip({
                    direction:'rl',
                    content: data,
                    onEnd: function(){
                        //$(".front").css('background-color', '#FFFFFF');
                        $(".previousFanArchive").attr('page-current',fanArchivePage);
                        $(".nextFanArchive").attr('page-current',fanArchivePage);
                        updateFlipNextPreviousButton(fanArchivePage,count);
                        // InitializeFancybox();
                    }
                });

            }, // callback
        );
    });

    /** Dependent function of  previousFanArchive & nextFanArchive */
    function updateFlipNextPreviousButton(fanArchivePage,totalfanArchivePage){
        if(fanArchivePage >=totalfanArchivePage){
            $(".flip_next").hide();
        }else{
            $(".flip_next").show();
        }
        if(fanArchivePage <= 1){
            $(".flip_previous").hide();
        }else{
            $(".flip_previous").show();
        }
    }

    // function InitializeFancybox(){
    //
    //     if($(".lightbox_images").length > 0){
    //         $(".lightbox_images").fancybox();
    //     }
    //
    //     if($(".fanbox").length>0){
    //         $(".fanbox").fancybox({
    //             margin : 25,
    //             padding: 10,
    //             scrolling : 'auto',
    //             preload   : true,
    //             type: 'iframe'
    //         });
    //     }
    //     if($(".lightbox_video").length>0){
    //         $(".lightbox_video").fancybox({
    //             type: 'iframe',
    //             scrolling : 'no',
    //             'iframe': {'scrolling': 'no'}
    //         });
    //     }
    //
    // }

}
